@if (filterItems.length > 6 && catalogView) {
  <mat-form-field>
    <mat-label>{{ 'default.companysInstructions' | blah }}</mat-label>
    <input type="text"
      matInput
      [formControl]="selectedCompany"
      [matAutocomplete]="auto"
      (change)="handleEmptyInput($event)">
    @if (selectedCompany.value) {
      <button
        matSuffix
        mat-icon-button
        (click)="emptySearch($event)">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete #auto="matAutocomplete"
      [displayWith]="displayFn"
      [panelWidth]="'auto'"
      (optionSelected)="selectProduct($event.option.value)">
      @for (option of filteredOptions | async; track option) {
        <mat-option
          [value]="option">
          {{option.name}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
}

@if (filterItems.length <= 6 || !catalogView) {
  <app-catalog-filter [stacked]="stacked"
    [items]="filterItems"
    (emitItemSelect)="selectProduct($event)">
  </app-catalog-filter>
}
